import script from "./SiweSign.vue?vue&type=script&setup=true&lang=ts"
export * from "./SiweSign.vue?vue&type=script&setup=true&lang=ts"

import "./SiweSign.vue?vue&type=style&index=0&id=8db041f8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8db041f8"]])

export default __exports__